import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#unless this.isHidden}}
  {{! filter-input-search prevents 1password from attempting autocomplete }}
  {{! template-lint-disable no-pointer-down-event-binding }}

  <Input
    tabindex={{0}}
    class="filter-input"
    placeholder={{this.computedPlaceholder}}
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    name="filter-input-search"
    spellcheck={{false}}
    @value={{readonly this.selectKit.filter}}
    @type="search"
    {{on "paste" (action "onPaste")}}
    {{on "keydown" (action "onKeydown")}}
    {{on "keyup" (action "onKeyup")}}
    {{on "input" (action "onInput")}}
  />

  {{#if this.selectKit.options.filterIcon}}
    {{d-icon this.selectKit.options.filterIcon class="filter-icon"}}
  {{/if}}
{{/unless}}
*/
{
  "id": "umxh76ys",
  "block": "[[[41,[51,[30,0,[\"isHidden\"]]],[[[1,\"\\n  \"],[8,[39,1],[[16,\"tabindex\",0],[24,0,\"filter-input\"],[16,\"placeholder\",[30,0,[\"computedPlaceholder\"]]],[24,\"autocomplete\",\"off\"],[24,\"autocorrect\",\"off\"],[24,\"autocapitalize\",\"off\"],[24,3,\"filter-input-search\"],[16,\"spellcheck\",false],[4,[38,3],[\"paste\",[28,[37,4],[[30,0],\"onPaste\"],null]],null],[4,[38,3],[\"keydown\",[28,[37,4],[[30,0],\"onKeydown\"],null]],null],[4,[38,3],[\"keyup\",[28,[37,4],[[30,0],\"onKeyup\"],null]],null],[4,[38,3],[\"input\",[28,[37,4],[[30,0],\"onInput\"],null]],null]],[[\"@value\",\"@type\"],[[28,[37,2],[[30,0,[\"selectKit\",\"filter\"]]],null],\"search\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"selectKit\",\"options\",\"filterIcon\"]],[[[1,\"    \"],[1,[28,[35,6],[[30,0,[\"selectKit\",\"options\",\"filterIcon\"]]],[[\"class\"],[\"filter-icon\"]]]],[1,\"\\n\"]],[]],null]],[]],null]],[],false,[\"unless\",\"input\",\"readonly\",\"on\",\"action\",\"if\",\"d-icon\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/multi-select/multi-select-filter.hbs",
  "isStrictMode": false
});